module.exports = __webpack_public_path__ + "images/xl-fujian.jpg?337728aacefe2179230ca83d0f4491d3";


//////////////////
// WEBPACK FOOTER
// ./src/images/active/xl-fujian.jpg
// module id = 205
// module chunks = 1